export default function tooltipKeepOnMouseover() {
  return {
    restrict: 'A',
    link($scope, $element) {
      $element.on('mouseenter', () => {
        $scope.$parent.$broadcast('tooltipCancelHide');
      });

      $element.on('mouseleave', () => {
        $scope.$parent.$broadcast('tooltipHide');
      });
    },
  };
}
